// Lista de monedas del mundo para los selects de "Monedas" del módulo de inventario.
// value = código ISO 4217; label incluye símbolo y nombre para elegir cómodo.
export const WORLD_CURRENCIES = [
  { code: "ARS", symbol: "AR$", name: "Peso argentino" },
  { code: "USD", symbol: "U$S", name: "Dólar estadounidense" },
  { code: "EUR", symbol: "€", name: "Euro" },
  { code: "BRL", symbol: "R$", name: "Real brasileño" },
  { code: "CLP", symbol: "CLP$", name: "Peso chileno" },
  { code: "UYU", symbol: "$U", name: "Peso uruguayo" },
  { code: "PYG", symbol: "₲", name: "Guaraní paraguayo" },
  { code: "BOB", symbol: "Bs", name: "Boliviano" },
  { code: "PEN", symbol: "S/", name: "Sol peruano" },
  { code: "COP", symbol: "COL$", name: "Peso colombiano" },
  { code: "MXN", symbol: "MX$", name: "Peso mexicano" },
  { code: "VES", symbol: "Bs.S", name: "Bolívar venezolano" },
  { code: "GBP", symbol: "£", name: "Libra esterlina" },
  { code: "CHF", symbol: "CHF", name: "Franco suizo" },
  { code: "CAD", symbol: "CA$", name: "Dólar canadiense" },
  { code: "AUD", symbol: "AU$", name: "Dólar australiano" },
  { code: "JPY", symbol: "¥", name: "Yen japonés" },
  { code: "CNY", symbol: "CN¥", name: "Yuan chino" },
];

const BY_CODE = new Map(WORLD_CURRENCIES.map((c) => [c.code, c]));

// Devuelve el símbolo a mostrar para un código (fallback al propio código).
export const currencySymbol = (code) => {
  if (!code) return "";
  return BY_CODE.get(code)?.symbol || code;
};

// Etiqueta legible para el select.
export const currencyLabel = (c) => `${c.symbol} — ${c.name} (${c.code})`;
